export default __webpack_public_path__ + "static/media/GoogleMapLocation.c86d640b.svg";